import { Dictionary } from 'lodash';
import camelCase from 'lodash-es/camelCase';
import mapKeys from 'lodash-es/mapKeys';
import { ACTION_TO_REPORT_POST, PROBLEM_WAS_REPORTED_THANK_YOU } from 'mk/autogenerated/translations/Complaint.sagas.3ed91dc23160ecddbc653d7e1b892020'
import { toastAdd } from 'mk2/actions';
import { PHONE_VERIFICATION_FORM_NAME } from 'mk2/apps/users/containers/PhoneVerification/PhoneVerification.constants';
import ServerErrorToast from 'mk2/components/toasts/ServerErrorToast';
import Toast from 'mk2/components/toasts/Toast';
import {
    complaintSave,
    complaintToggle,
    ComplaintOpenTriggerAction,
    ComplaintSendAction,
    COMPLAINT_OPEN_TRIGGER,
    COMPLAINT_SEND,
} from 'mk2/containers/Complaint/Complaint.actions';
import { saveComplaint as apiSaveComplaint } from 'mk2/containers/Complaint/Complaint.api';
import { generateFormName } from 'mk2/containers/Complaint/Complaint.helpers';
import { ComplaintSchema } from 'mk2/containers/Complaint/Complaint.schemas';
import { XHRAction } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { checkIfUserIsLoggedIn } from 'mk2/sagas/auth';
import { normalize } from 'normalizr';
import React from 'react';
import { reset, stopSubmit } from 'redux-form';
import { all, call, put, takeEvery } from 'redux-saga/effects';

const logger = getLogger('Complaint.sagas');

export function* openComplaint({ entity, id }: ComplaintOpenTriggerAction) {
    if (!(yield call(checkIfUserIsLoggedIn, ACTION_TO_REPORT_POST))) {
        return;
    }
    yield put(complaintToggle(entity, id, true));
}

export function* saveComplaint({ entity, id, complaint, xhr }: ComplaintSendAction & XHRAction) {

    yield put(complaintSave.request(entity, id, complaint));

    const formName = generateFormName(entity, id);

    try {
        const response = yield call(apiSaveComplaint, xhr, entity, id, complaint);
        const normalizedResponse = normalize(response.body.complaint, ComplaintSchema);
        yield put(complaintSave.success(entity, id, complaint, normalizedResponse));

        // Display toast message
        yield put(toastAdd('success', {
            component: ({ remove }) => (
                <Toast type="success" remove={remove}>
                    {PROBLEM_WAS_REPORTED_THANK_YOU}
                </Toast>
            ),
        }));

        // Hide the complaint form
        yield put(complaintToggle(entity, id, false));

        // Stop submit
        yield put(stopSubmit(formName));

        // Reset form
        yield put(reset(formName));

    } catch (error) {
        if (error.response.body && error.response.body.errors) {
            yield put(stopSubmit(formName, error.response.body.errors));
        } else {
            yield put(stopSubmit(formName));
            if (error.status === 400) {
                // Complaints are ignored - maybe user has old client data
                // Reload page
                location.reload();
            }

            logger.error(error);

            // Display toast message
            yield put(toastAdd('error', {
                component: ServerErrorToast,
            }));
        }
        yield put(complaintSave.failure(entity, id, complaint, error));
    }
}

export default function* root() {
    yield all([
        takeEvery(COMPLAINT_SEND, saveComplaint),
        takeEvery(COMPLAINT_OPEN_TRIGGER, openComplaint),
    ]);
}
